import { render, staticRenderFns } from "./AuditHeader.vue?vue&type=template&id=13b4a5d9"
import script from "./AuditHeader.vue?vue&type=script&lang=js"
export * from "./AuditHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports